import { ChatActionWithValue } from '../../models/insuranceApplication'
import { ConnectTerminalTelematics } from '../ConnectTerminalTelematics'

export interface ChatAddTelematicsProps {
  handleSubmit: (data: ChatActionWithValue | FormData) => void
  label: string
  isPostBind: boolean
  readonly?: boolean
}

export function ChatAddTelematics({ handleSubmit, label, isPostBind, readonly }: ChatAddTelematicsProps) {
  function handleConnected() {
    handleSubmit({
      content: {
        component: 'P',
        content: label,
      },
      value: 'TELEMATICS_CONNECTED',
    })
  }

  return (
    <div className="flex flex-col justify-end gap-2">
      <ConnectTerminalTelematics
        handleSuccess={handleConnected}
        buttonProps={{ variant: 'outlineThin', size: 'sm', children: label, disabled: readonly }}
        type={isPostBind ? 'POST_BIND' : 'PRE_BIND'}
      />
    </div>
  )
}
